import { useState } from 'react';
import { Modal, Form, Input, Button, Upload, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { uploadFile } from '../../../../apis/OdooMovimientoEmpleadoApi';

const ModalCartaUploadFiles = ({ title, open, finish, odoo_movimiento }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [cartaFile, setCartaFile] = useState(null);
  const [cartaFileName, setCartaFileName] = useState(null);

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  };


  const onFinish = async (values) => {
    setLoading(true);
    try {
      // Convertir archivos a Base64
      const cartaBase64 = await fileToBase64(cartaFile);

      // Preparar payload para el backend
      const payload = {
        odoo_empleado_id: odoo_movimiento.odoo_empleado_id,
        type: "finiquito",
        file_base64: cartaBase64.split(',')[1], // Quitar el prefijo data:...
        filename: cartaFileName
      };

      debugger;
      // Llamar al servicio de API
      const response = await uploadFile(payload);
      
      if (response.ok) {
        message.success('Comprobante subido correctamente');
        finish(true); // Cierra el modal y refresca los datos
      } else {
        throw new Error(response.message || 'Error al subir el comprobante');
      }
    } catch (error) {
      console.error('Error:', error);
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const beforeUpload = (file, type) => {
    setCartaFile(file);
    setCartaFileName(file.name);
    return false;
  };

  return (
    <Modal
      title={title}
      open={open}
      onCancel={() => finish(false)}
      footer={null}
      width={600}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          label="Carta firmada"
          required
        >
          <Upload
            beforeUpload={(file) => beforeUpload(file)}
            maxCount={1}
            fileList={cartaFile ? [cartaFile] : []}
            onRemove={() => setCartaFile(null)}
          >
            <Button icon={<UploadOutlined />}>Seleccionar archivo .PDF o PNG</Button>
          </Upload>
        </Form.Item>

        <Form.Item>
          <Button 
            type="primary" 
            htmlType="submit" 
            loading={loading}
            disabled={!cartaFile}
            block
          >
            Subir Archivos
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalCartaUploadFiles;